import { activityLabelSchema, massToGrams, type MassDisplayUnit } from '@baby-tracker/validation';
import { useState, type ReactElement } from 'react';

import { Button } from '../../ui/Button.js';
import { FormError } from '../../ui/FormError.js';
import { Sheet } from '../../ui/Sheet.js';
import fieldStyles from '../../ui/fields.module.css';
import { TextField } from '../../ui/TextField.js';

export function SolidSheet({
    open,
    unit,
    pending,
    error,
    onClose,
    onSave,
}: {
    open: boolean;
    unit: MassDisplayUnit;
    pending: boolean;
    error: string | null;
    onClose: () => void;
    onSave: (input: { foodDescription: string; amountG?: number }) => Promise<void>;
}): ReactElement {
    const [food, setFood] = useState('');
    const [amount, setAmount] = useState('');
    const [formError, setFormError] = useState<string | undefined>();

    return (
        <Sheet title="Solid" open={open} onClose={onClose}>
            <form
                className={fieldStyles.stack}
                noValidate
                onSubmit={(event) => {
                    event.preventDefault();
                    const parsedFood = activityLabelSchema.safeParse(food);
                    if (!parsedFood.success) {
                        setFormError('Describe the food.');
                        return;
                    }
                    const trimmed = amount.trim();
                    if (trimmed.length === 0) {
                        setFormError(undefined);
                        void onSave({ foodDescription: parsedFood.data });
                        return;
                    }
                    const parsed = Number(trimmed);
                    if (!Number.isFinite(parsed) || parsed <= 0) {
                        setFormError('Enter a number greater than 0');
                        return;
                    }
                    setFormError(undefined);
                    void onSave({
                        foodDescription: parsedFood.data,
                        amountG: massToGrams(parsed, unit),
                    });
                }}
            >
                <TextField
                    label="Food"
                    autoComplete="off"
                    value={food}
                    onChange={(event) => {
                        setFood(event.target.value);
                    }}
                />
                <TextField
                    label={`Amount (${unit}, optional)`}
                    inputMode="decimal"
                    autoComplete="off"
                    value={amount}
                    onChange={(event) => {
                        setAmount(event.target.value);
                    }}
                />
                <FormError message={formError ?? error} />
                <Button type="submit" loading={pending}>
                    Save solid
                </Button>
            </form>
        </Sheet>
    );
}
